import { CardProduct } from 'components/Cards/CardProduct'
import { Box } from '@achieve/ascend'
import { BaseCarousel } from 'components/Carousels/BaseCarousel'
import { CardProductListItem } from 'components/Cards/CardProductListItem'

function Card({ item, productCardVariant }) {
  return (
    <div className={'flex flex-col h-full px-4 py-0'}>
      {item && productCardVariant === 'ProductCardsListItem' ? (
        <CardProductListItem content={item} />
      ) : (
        <CardProduct content={item} />
      )}
    </div>
  )
}

function CardCarousel({ content = {}, isMobile, productCardVariant }) {
  const items = content?.gridItems || []
  const containsCardBadge = items.some((item) => item.fields?.cardBadgeImage)
  const trackClassName = containsCardBadge ? 'justify-start pt-12 pb-4 px-0' : 'justify-start py-4'

  if (productCardVariant === 'ProductCardsListItem') {
    return (
      <Box data-variant="carousel" data-testid="value-props-carousel-container">
        <BaseCarousel
          items={items}
          renderItem={(cardItem) => (
            <Card item={cardItem} productCardVariant={productCardVariant} />
          )}
          hideControls={true}
          hideIndicators={true}
          classNameTrack="gap-4 w-[99%] justify-start"
          classNameSlide="w-auto last:mr-[88px]"
        />
      </Box>
    )
  }

  return (
    <Box data-testid="value-props-carousel-container">
      <BaseCarousel
        items={items}
        renderItem={(cardItem) => <Card item={cardItem} productCardVariant={productCardVariant} />}
        hideIndicators={!isMobile}
        hideControls={false}
        classNameTrack={trackClassName}
        classNameSlide="w-[85%] md:w-[65%] lg:w-[30%] lg:first:pl-[88px] xl:w-[27.5%]"
        classNameIndicators="[&>div]:bg-[#c0cbd8]"
      />
    </Box>
  )
}

export { CardCarousel }
